import { render, staticRenderFns } from "./xml_display.vue?vue&type=template&id=68536edb&scoped=true&"
import script from "./xml_display.vue?vue&type=script&lang=js&"
export * from "./xml_display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68536edb",
  null
  
)

export default component.exports